import React from 'react'
import pandaImg from '../../../src/assets/images/404.png'

function AuditError() {
  return (
    <div style={{backgroundColor: '#ffffff'}}>
      <div className="container error-msg-container">
        <div className="row">
          <div className="col-sm-6 col-md-6">
            <img alt="404" className="img-responsive hidden-xs hidden-sm" src={pandaImg} />
          </div>
          <div className="col-sm-6 col-md-6">
            <h3 className="support-error-heading">404 Audit not found</h3>
            <h5 className="support-error-msg">"Audit you are looking for can not be found"</h5>
          </div>
        </div>
      </div>
    </div>
  )
}
export default AuditError
